// 10h for the big pieces of work (projects, papers, exam prep) a category can hold.
export const TIME_PRESETS = [15, 30, 45, 60, 90, 120, 180, 300, 600];
export const TIME_PRESET_LABELS = ['15m', '30m', '45m', '1h', '1.5h', '2h', '3h', '5h', '10h'];

export const PAGE_PRESETS = [5, 10, 15, 20, 30, 50];

export const RATE_PRESETS_SECONDS = [90, 120, 180, 300, 480];
export const RATE_PRESET_LABELS = ['1m 30s/p', '2m/p', '3m/p', '5m/p', '8m/p'];

export const SELECTION_ERROR_MSG =
  "Readings (estimated in pages) and other tasks (estimated in time) can't be selected together — clear your selection first.";

export const STANDALONE_SECTION_KEY = 'standalone';

export const sourceSectionKey = (sourceId: number) => `src-${sourceId}`;

export const categorySectionKey = (categoryId: number) => String(categoryId);
